module.exports = __webpack_public_path__ + "static/1157237485.55f60f14.jpg";